"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var QuickAddToListBase_1 = __importDefault(require("@components/QuickAddToListBase"));
function QuickAddToList(props) {
    return (react_1.default.createElement(QuickAddToListBase_1.default, __assign({}, props, { kind: "MIXED", spanClassName: "quick-add-to-list__icon implioicons-add-to-list eva-tooltip-container--center", singleSelectClassName: "eva-single-select-with-search" })));
}
exports.default = QuickAddToList;
